import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const container = styled('div')`
  padding: 20px;
`;

const redBox = styled('div')`
  background-color: #f65959;
  height: 300px;
  padding: 35px;
`;

const accessDeniedText = styled('div')`
  height: 38px;
  font-size: var(--ph-heading-one);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
`;

const accessDeniedSmallText = styled('div')`
  width: 362px;
  height: 22px;
  font-size: var(--ph-text-sm);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: var(--white);
  margin: 10px 0 0 40px;
`;

const openMainPageButton = styled('span')`
  position: relative;
  top: 120px;
  width: 215px;
  height: 60px;
  border-radius: var(--ph-border-radius-sm);
  border: solid 2px var(--white);
  padding: 15px;
  margin: 0 0 0 40px;
`;

const openMainPageButtonText = styled('span')`
  width: 1147px;
  height: 257px;
  background-color: #f65959;
  color: var(--white);
`;

const icon = styled(Svg)`
  width: 30px;
  height: 30px;
  top: 2px;
`;

export default {
  Icon: icon,
  RedBox: redBox,
  Container: container,
  AccessDeniedText: accessDeniedText,
  AccessDeniedSmallText: accessDeniedSmallText,
  OpenMainPageButton: openMainPageButton,
  OpenMainPageButtonText: openMainPageButtonText,
};
